import { sanitizeStripePublishableKey } from './stripeKey';

export const config = {
  env: process.env.REACT_APP_ENV,
  //apiUrl: process.env.REACT_APP_API_URL,
  cdnUrl: process.env.REACT_APP_CDN_URL,
  hostUrl: process.env.REACT_APP_HOST,
  // Where the upload-link page posts files (the backend's UPLOAD_SERVER_URL).
  // Production uses the upload host, which bypasses Cloudflare's body limit.
  uploadServerUrl: process.env.REACT_APP_UPLOAD_SERVER_URL || process.env.REACT_APP_HOST,
  rbgEndpointUrl: process.env.REACT_APP_RBG_ENDPOINT_URL ?? 'https://rbg-addon-eu.filespin.io',
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  sentryRelease: process.env.REACT_APP_SENTRY_RELEASE,
  JWTExpiration: process.env.REACT_APP_JWT_EXPIRATION,
  filespinLoader: process.env.REACT_APP_FILESPIN_LOADER ?? '',
  boardingTourMapping: process.env.REACT_APP_BOARDING_TOUR_MAP ?? 'dev',
  notificationsRefetchInterval: parseInt(process.env.REACT_APP_NOTIFICATION_REFETCH_INTERVAL ?? '10000'),
  defaultSchemaId: 0,
  showTour: process.env.REACT_APP_SHOW_TOUR === 'true',
  showStorageStats: process.env.REACT_APP_SHOW_STORAGE_STATS === 'true',
  showDataTransferredStats: process.env.REACT_APP_SHOW_DATA_TRANSFERRED_STATS === 'true',
  showHelpIcon: process.env.REACT_APP_SHOW_HELP_ICON === 'true',
  showQueueStats: process.env.REACT_APP_SHOW_QUEUE_STATS === 'true',
  showTaskQueues: process.env.REACT_APP_SHOW_TASK_QUEUES === 'true',
  showTeleportStats: process.env.REACT_APP_SHOW_TELEPORT_STATS === 'true',
  showSubscription: process.env.REACT_APP_SHOW_SUBSCRIPTION === 'true',
  // Plan codes to withhold from the self-serve offer — the "Change plan"
  // picker and the CTA that leads to it. Comma-separated, e.g.
  // "STARTER,TEAM". This is how a tier is GRANDFATHERED: accounts already on
  // it keep it untouched, and it simply stops being something to switch to.
  // Empty/unset hides nothing. Upper-cased once here so callers can compare
  // without re-normalising, and so a deployment that typed "starter" still
  // gets the plan it meant to retire. See
  // admin-pages/Subscription/planVisibility.ts.
  hiddenPlanCodes: (process.env.REACT_APP_HIDDEN_PLAN_CODES ?? '')
    .split(',')
    .map((code) => code.trim().toUpperCase())
    .filter(Boolean),
  // Stripe publishable key (pk_test_… / pk_live_…). Used as the frontend
  // "billing configured" signal: when empty, the self-serve checkout + payment
  // CTAs fall back to contact-support copy. Checkout/portal themselves run via
  // backend-created session URLs (hosted redirect), so the key is only a gate.
  //
  // Sanitised, not read raw: a key Stripe.js refuses is not a configured key,
  // and treating any non-empty string as "configured" is what let a legacy-format
  // key take prod's whole self-serve checkout down silently on 2026-08-31. See
  // utils/stripeKey.ts for the full failure mode.
  stripePublishableKey: sanitizeStripePublishableKey(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  ),
  showDeliveryAnalytics: process.env.REACT_APP_SHOW_DELIVERY_ANALYTICS === 'true',
  // Configure > Migrate to FileSpin (leaving Cloudinary / ImageKit).
  //
  // Default OFF, like every other deployment-scoped feature flag here, because
  // the screen is only useful where the `migration-onramp` service is actually
  // running: without it every call answers 503 and the page is a dead end. Turn
  // it on for a stack that has migration-onramp deployed.
  showMigration: process.env.REACT_APP_SHOW_MIGRATION === 'true',
  onboardingGuideVideos: (() => {
    try {
      return JSON.parse(process.env.REACT_APP_ONBOARDING_GUIDE_VIDEOS || '{}');
    } catch {
      return {};
    }
  })(),
  workflowsUrl: process.env.REACT_APP_WORKFLOWS_URL ?? '',
  mcpDocsUrl: process.env.REACT_APP_MCP_DOCS_URL ?? '',
  apiDocsUrl: process.env.REACT_APP_API_DOCS_URL ?? '',
  // Adobe Creative Cloud marketplace listing for the FileSpin plugin. Empty
  // until the listing is approved AND the plugin can actually sign in and save
  // against this deployment, and that emptiness is the feature gate: the
  // "Edit in Adobe apps" menu item does not render without it, so we never send
  // a customer to install something that fails on its first save.
  adobePluginUrl: process.env.REACT_APP_ADOBE_PLUGIN_URL ?? '',
  chatEnabled: process.env.REACT_APP_CHAT_ENABLED === 'true',
  chatProxyUrl: process.env.REACT_APP_CHAT_PROXY_URL ?? '',
  mcpOauthClientId:
    process.env.REACT_APP_MCP_OAUTH_CLIENT_ID ?? 'filespin-ai-agent-scheduler',
  aiAgentScheduleOauthClientId:
    process.env.REACT_APP_AI_AGENT_SCHEDULE_OAUTH2_CLIENT_ID ?? 'filespin-ai-agent-scheduler',
};
